/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Topic_Description_PlaceholderInputs */



/**
* | output |
* | --- |
* | "What is this topic about?" |
*
* @param {Settings_Template_Topic_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_topic_description_placeholder = /** @type {((inputs?: Settings_Template_Topic_Description_PlaceholderInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Topic_Description_PlaceholderInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Waar gaat dit onderwerp over?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("De quoi parle ce sujet ?")
	return /** @type {LocalizedString} */ ("What is this topic about?")
});